import { GetAllExchangeRateResponse, GetExchangeRateResponse } from 'Application/models';
import { AxiosResponse } from 'axios';
import { APICallInstance } from './APICallInstance';

const exchangeRateUrl = '/api/v1/exchange-rates';

class ExchangeRateServiceClass {
    getExchangeRate = async (fromCurrency: string, toCurrency: string) => {
        try {
            const response: AxiosResponse<GetExchangeRateResponse> = await APICallInstance.get(exchangeRateUrl, {
                params: {
                    fromCurrency,
                    toCurrency
                }
            });
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    getAllExchangeRates = async () => {
        const url = `${exchangeRateUrl}/all`;

        try {
            const response: AxiosResponse<GetAllExchangeRateResponse> = await APICallInstance.get(url);
            console.log('All exchange rates response: ', response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    updateExchangeRate = async (fromCurrency: string, toCurrency: string, rate: number) => {
        const url = `${exchangeRateUrl}/update`;

        try {
            const response: AxiosResponse<GetExchangeRateResponse> = await APICallInstance.put(
                url,
                {},
                {
                    params: {
                        fromCurrency,
                        toCurrency,
                        rate
                    }
                }
            );
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    addExchangeRate = async (fromCurrency: string, toCurrency: string, rate: number) => {
        const url = `${exchangeRateUrl}/create`;

        try {
            const response: AxiosResponse<GetExchangeRateResponse> = await APICallInstance.post(
                url,
                {},
                {
                    params: {
                        fromCurrency,
                        toCurrency,
                        rate
                    }
                }
            );
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };
}

export const ExchangeRateService = new ExchangeRateServiceClass();
